import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {PublishingRecordForButton} from 'notebook/template-publishing/graphql/types';
import {
  PublishableVersionStatus,
  PUBLISHABLE_VERSION_STATUS_TO_ICON,
  PUBLISHABLE_VERSION_STATUS_TO_COLOR,
  PublishableVersionAction,
} from 'notebook/template-publishing/TemplatePublishingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {capitalize} from 'util/NameUtil';

export interface TemplatePublishingChipProps {
  versionName: string;
  status: PublishableVersionStatus;
}

export function TemplatePublishingChip({versionName, status}: TemplatePublishingChipProps): JSX.Element {
  const iconName = PUBLISHABLE_VERSION_STATUS_TO_ICON[status];
  const iconColor = PUBLISHABLE_VERSION_STATUS_TO_COLOR[status];

  return (
    <Tooltip text={capitalize(status)}>
      <div className={classNames('template-publishing-chip', css(styles.chipContainer))}>
        <span className={css(styles.spanContainer)} style={{color: iconColor}}>
          <BenchlingIcon icon={iconName} />
        </span>
        <span className={css(styles.spanContainer)}>{versionName}</span>
      </div>
    </Tooltip>
  );
}

export default function TemplatePublishingChipsWithArrow({
  publishingAction,
  currentPublishingRecord,
  versionName,
}: {
  publishingAction: PublishableVersionAction;
  currentPublishingRecord: PublishingRecordForButton;
  versionName: string;
}): JSX.Element {
  const isPublish = publishingAction === PublishableVersionAction.PUBLISH;
  const leftVersionName = isPublish ? 'Draft' : currentPublishingRecord.versionName;
  const rightVersionName = isPublish ? versionName : currentPublishingRecord.versionName;
  const leftStatus = isPublish ? PublishableVersionStatus.DRAFT : PublishableVersionStatus.EFFECTIVE;
  const rightStatus = isPublish ? PublishableVersionStatus.EFFECTIVE : PublishableVersionStatus.WITHDRAWN;
  return (
    <div>
      <TemplatePublishingChip status={leftStatus} versionName={leftVersionName} />
      <BenchlingIcon icon="arrow-right" style={{margin: '0 1em', color: Color.GRAY_400}} />
      <TemplatePublishingChip status={rightStatus} versionName={rightVersionName} />
    </div>
  );
}

const styles = StyleSheet.create({
  chipContainer: {
    display: 'inline-block',
    backgroundColor: Color.GRAY_100,
    padding: '0.5em 1em',
    borderRadius: '150px',
    fontSize: '14px',
    fontWeight: 'bold',
    border: 'none',
  },
  spanContainer: {
    marginLeft: '0.2em',
    marginRight: '0.2em',
  },
});
